export default __webpack_public_path__ + "static/media/filter.3524123b.svg";